<template>
  <div class="home">
    xxxxxxxxxx
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {}
}
</script>
